import React from 'react'
import { SiteHeader as Component } from '@swp/components'

export default function SiteHeader(props) {
return (
  <Component className="pos--fix --size-M" type={"SiteHeader"} item={{"color":"rgba(255,255,255,1)","colorHover":"rgba(255,197,20,1)","className":"fs--18"}} fixed={true} items={[{"id":"3gxcfh142vxn","use":"page","name":"Ceník","page":"/cenik"},{"id":"o2nyy2xv8clw","use":"page","name":"Reference","page":"/reference"},{"id":"h7sdv7vumawa","use":"page","name":"Kontakt","page":"/kontakt"}]} title={{"color":"rgba(255,255,255,1)","content":"Profesionální úklid Olomouc","className":"fs--24"}} layout={"3"} backgroundColor={"rgba(10,52,138,1)"} button={{"className":"btn-box"}} />
)
}